import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { applyCustomCode, forgetCustomAssets } from '../lib/customCode';
import { cacheAdminPathIsPortal, isPanelPath } from '../lib/adminDomain';
import { skinEligible } from '../lib/betrunSkin';
import { startBetrunSkinScript } from '../themes/betrun/betrunSkin';

const CustomCodeInjector = () => {
  const settings = useSettings();
  const { pathname } = useLocation();
  // Panel kilitliyken ana sitedeki /admin portalın 404 sayfasıdır ve temanın
  // geri kalanı gibi özel kodu da taşır (bkz. lib/adminDomain.isPanelPath).
  const isAdmin = isPanelPath(settings, pathname);
  const adminDomainEnabled = settings.admin_domain_enabled;
  const adminDomainLocked = settings.admin_domain_locked;
  const adminHost = settings.admin_host;
  // Parçalar ``settings`` satırında değil kendi tablosundadır: CSS ve JS
  // **adres olarak** gelir (dosya tarayıcı önbelleğine girsin diye), satır içi
  // slotlar ham HTML olarak. Bkz. backend/services/custom_code.py.
  const code = settings.custom_code || {};
  const cssUrl = code.css_url || '';
  const jsUrl = code.js_url || '';
  const headerCode = code.header || '';
  const bodyCode = code.body || '';
  const footerCode = code.footer || '';
  const skinOn = skinEligible(settings) === true;

  useEffect(() => {
    if (!settings.settingsLoaded) return;
    // Uygulama durumu modülde tutulur (bkz. lib/customCode.js): aynı satır içi
    // kod ikinci kez çalıştırılmaz, panele geçişte düğümler sökülür, portala
    // dönüşte aynı düğümler geri takılır. Efektin temizleme adımı bilinçli
    // olarak yoktur — sökme kararını `enabled` verir; cleanup'ta sökmek
    // StrictMode'da ve her ayar yenilemesinde widget'ı ikinci kez yükletiyordu.
    // Kurulum kısıtlıyken portal yerine tam ekran duyuru çizilir; canlı destek
    // gibi widget'ların o ekranın üstünde açılmaması için kodlar da uygulanmaz.
    if (settings.site_locked) forgetCustomAssets();
    cacheAdminPathIsPortal({
      admin_domain_enabled: adminDomainEnabled,
      admin_domain_locked: adminDomainLocked,
      admin_host: adminHost,
    });
    applyCustomCode({
      cssUrl,
      jsUrl,
      headerCode,
      bodyCode,
      footerCode,
      enabled: !isAdmin && !settings.site_locked,
    });
    // Betrun'un paketlenmiş davranışları özel JS'in yerini tutar ve onunla
    // aynı kapıdan geçer: portal, kilitsiz kurulum — ve yalnızca kurulumun
    // kendi özel CSS/JS'i yokken (bkz. lib/betrunSkin.js). Bir kez çalışır.
    if (!isAdmin && !settings.site_locked && skinOn) {
      startBetrunSkinScript();
    }
  }, [
    skinOn,
    adminDomainEnabled, adminDomainLocked, adminHost,
    bodyCode, cssUrl, footerCode, headerCode, isAdmin, jsUrl,
    settings.settingsLoaded, settings.site_locked,
  ]);

  return null;
};

export default CustomCodeInjector;
